import React from 'react';
import { DashboardClosedByPOCPivotMode } from '../../../../../constants/DashboardClosedByPOCPivotMode';
import { DashboardClosedByPOCPivotModeToggleButton } from './components/DashboardClosedByPOCPivotToggleButton';
import { ClosedMonthDropDownBox } from './components/ClosedMonthDropDownBox';

export const Toolbar: React.FC<{
    pivotMode: DashboardClosedByPOCPivotMode;
    set_pivotMode: (mode: DashboardClosedByPOCPivotMode) => void;
    closedMonth: string | null;
    set_closedMonth: (value: string) => void;
    dashboardClosedAvailableClosedMonths: { key: string; display: string }[];
}> = ({ pivotMode, set_pivotMode, closedMonth, set_closedMonth, dashboardClosedAvailableClosedMonths }) => {
    return (
        <div className='mode-bar'>
            <div className='mode-item'>
                Closed by POC
                <span className='dropdown-wrapper'>
                    <ClosedMonthDropDownBox
                        closedMonth={closedMonth}
                        set_closedMonth={set_closedMonth}
                        dashboardClosedAvailableClosedMonths={dashboardClosedAvailableClosedMonths}
                    />
                </span>
                <span className='toggle-wrapper'>
                    <DashboardClosedByPOCPivotModeToggleButton
                        pivotMode={pivotMode}
                        set_pivotMode={set_pivotMode}
                    />
                </span>
            </div>
        </div>
    );
};
